import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Axios from "middleware/axiosInstance";
import { Row, Col } from "antd";
import "antd/dist/antd.css";
import useAxios from "middleware/useAxios";
import { Button, Form, Input, Select, Space } from "antd";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import Icon from "react-multi-date-picker/components/icon";
import OpenNotificationWithIcon from "layouts/notificationWithIcon/OpenNotificationWithIcon ";
import { convertToMiladi } from "utils/dateCoverter";

const { Option } = Select;
const { TextArea } = Input;

const PrefaktorCustomerInfo = ({ setPrefaktorInfo, sendPreFactorToServer }) => {
  const Navigate = useNavigate();
  const [form] = Form.useForm();

  const [clearingDate, setClearingDate] = useState();
  const [todayDate, setTodayDate] = useState([{}]);

  // const [prefaktorInfo, setPrefaktorInfo] = useState(null);

  const [allPeople] = useAxios({
    method: "get",
    url: "/people",
  });

  const [allCommodity] = useAxios({
    method: "GET",
    url: "/commodity",
  });

  useEffect(() => {
    console.log(allCommodity);
  }, [allCommodity]);

  const changeDateOfDocHandler = (e) => {
    console.log(e);
    const dateInShamsi = `${e.year}-${e.month.number}-${e.day}`;
    console.log(dateInShamsi);
    const dateInMiladi = convertToMiladi(dateInShamsi);
    console.log(dateInMiladi);
    setClearingDate({ shamsi: dateInShamsi, miladi: dateInMiladi });
    // console.log(({ calendar: persian, locale: persian_fa }))
  };
  const handleFormValuesSubmit = (prefaktorInfo) => {
    clearingDate
      ? (prefaktorInfo.clearingDate = clearingDate)
      : alert("tarikh vared konid");
    setPrefaktorInfo(prefaktorInfo);
    sendPreFactorToServer(prefaktorInfo);
  };

  return (
    <div className="d-print-none">
      <Form
        // layout="horizental"
        layout="vertical"
        // layout="inline"
        // {...formItemLayout}
        // layout={
        //     "span": 12,
        //     "offset": 12,
        //   },
        initialValues={{
          items: [{ radif: "1" }],
          // features: [{ feature: "", feature_value: "0" }]
        }}
        form={form}
        // onValuesChange={handleFormValuesChange}
        autoComplete="off"
        scrollToFirstError
        labelCol={{ xs: 24 }}
        onFinish={handleFormValuesSubmit}
      >
        <Row gutter={8}>
          {/* <Col xs={24} sm={12} md={8} xl={6}>
                        <Form.Item
                            label="عنوان"
                            name="customerNamePrefix"
                        rules={[
                            {
                                required: true,
                                message: "انتخاب شخص اجباری می باشد",
                            },
                        ]}
                        >
                            <Select
                                // className={`${classNames.classes}`}
                                // loading={!allPeople?.[0]}
                                // showSearch
                                // style={{
                                //   width: 200,
                                // }}
                                fieldNames="customerNamePrefix"
                                placeholder="انتخاب فرمایید"
                                optionFilterProp="children"
                                // filterOption={(input, option) =>
                                //     option.children.includes(input)
                                // }
                                // filterSort={(optionA, optionB) =>
                                //     optionA.children
                                //         .toLowerCase()
                                //         .localeCompare(optionB.children.toLowerCase())
                                // }
                                id="customerNamePrefix"
                            >

                                <Option value={"شرکت"}>
                                    شرکت
                                </Option>
                                <Option value={"مجموعه"}>
                                    مجموعه
                                </Option>
                                <Option value={"جناب آقای"}>
                                    جناب آقای
                                </Option>
                                <Option value={"سرکار خانم"}>
                                    سرکار خانم
                                </Option>

                            </Select>
                        </Form.Item>
                    </Col> */}
          <Col xs={24} sm={12} md={8} xl={6}>
            <Form.Item
              label="شخص"
              name="people_id"
              rules={[
                {
                  required: true,
                  message: "انتخاب شخص اجباری می باشد",
                },
              ]}
            >
              <Select
                // className={`${classNames.classes}`}
                loading={!allPeople?.[0]}
                showSearch
                // style={{
                //   width: 200,
                // }}
                fieldNames="people_id"
                placeholder="انتخاب فرمایید"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.includes(input)
                }
                filterSort={(optionA, optionB) =>
                  optionA.children
                    .toLowerCase()
                    .localeCompare(optionB.children.toLowerCase())
                }
                id="people_id"
              >
                {allPeople?.map((people) => {
                  return (
                    // <Option key={people.id} value={JSON.stringify(people)}>
                    <Option key={people.id} value={people.id}>
                      {`${people.name} ${people.family}`}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={8} xl={6}>
            <Form.Item
              label="مهلت تسویه"
              name="date"
              rules={[
                {
                  required: !clearingDate,
                  message: "انتخاب تاریخ الزامی می باشد",
                },
              ]}
            >
              <Input
                disabled
                placeholder={clearingDate?.shamsi || "انتخاب تاریخ"}
                addonBefore={
                  <DatePicker
                    onChange={(e) => changeDateOfDocHandler(e)}
                    calendar={persian}
                    locale={persian_fa}
                    calendarPosition="bottom-left"
                    format="HH:MM"
                    // plugins={[<TimePicker hideSeconds />]}
                    render={
                      <Icon
                        style={{
                          color: "gray",
                          width: "23px",
                        }}
                      />
                    }
                  />
                }
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={8}>
          <Col xs={24}>
            <Form.List
              name="items"
              onValuesChange={(e) => {
                console.log(e);
              }}
            >
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Space
                      key={key}
                      style={{ display: "flex", marginBottom: 8 }}
                      align="baseline"
                    >
                      <Form.Item
                        {...restField}
                        name={[name, "radif"]}
                        label="ردیف"
                      >
                        {/* row number */}
                        {name + 1}
                      </Form.Item>

                      <Form.Item
                        {...restField}
                        name={[name, "commodity_id"]}
                        label="شناسه/نام کالا"
                        rules={[
                          {
                            required: true,
                            message: "انتخاب کالا اجباری است",
                          },
                        ]}
                      >
                        <Select
                          showSearch
                          loading={!allCommodity?.[0]}
                          placeholder="انتخاب فرمایید"
                          optionFilterProp="children"
                          filterOption={(input, option) =>
                            option.children.includes(input)
                          }
                          filterSort={(optionA, optionB) =>
                            optionA.children
                              .toLowerCase()
                              .localeCompare(optionB.children.toLowerCase())
                          }
                        >
                          {allCommodity?.map((commodity, index) => {
                            return (
                              // to get all of commodity object as a value, we convert to string
                              // <Option key={commodity.id} value={JSON.stringify(commodity)}>
                              <Option key={commodity.id} value={commodity.id}>
                                {`${commodity.id} -${commodity.name}`}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>

                      <Form.Item
                        {...restField}
                        name={[name, "count"]}
                        label="تعداد"
                        rules={[
                          {
                            required: true,
                            message: "تعداد کالا اجباری است",
                          },
                          { min: 1 },
                          () => ({
                            validator(_, value) {
                              if (value < 1) {
                                return Promise.reject("حداقل تعداد 1");
                              } else return Promise.resolve();
                            },
                          }),
                        ]}
                      >
                        <Input type="number" placeholder="100" onWheel={(e) => e.target.blur()}/>
                      </Form.Item>
                      <Form.Item
                        {...restField}
                        label="شرح"
                        name={[name, "description"]}
                      >
                        <TextArea
                          row={3}
                          autoSize={{ minRows: 1, maxRows: 4 }}
                          placeholder="توضیحات..."
                        />
                      </Form.Item>
                      <MinusCircleOutlined
                        onClick={() => {
                          remove(name);
                        }}
                      />
                    </Space>
                  ))}
                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                    >
                      ایجاد یک ردیف جدید
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </Col>
        </Row>
        <Form.Item
        // {...buttonItemLayout}
        >
          <Button
            htmlType="submit"
            type="primary"
            // onClick={CreateWarehouseEntryDocumentHandler}
          >
            ثبت پیش فاکتور
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default PrefaktorCustomerInfo;
